import { api } from "../../services/Api.js";
import Vue from 'vue';

export function get_chat_persons({ commit, state }, payload ){

    // adding token
    payload.token=state.appSettings.token

   
    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    
    // return chainable promise
    return api
    .post(school,"get_chat_persons.php",payload)
    .then( result =>{
      //console.dir(result.data);
      commit('SET_CHAT_PERSONS', {chatpersons:result.data});
      return result;
    })
    .catch( error => {
      Vue.$toaster.toast("[error: action get_chat_persons]" + error);
     
    })
    

}